module.exports = __webpack_public_path__ + "static/media/truck.ea846f0e.svg";